<template>
  <div>
    <div class="row">
      <iframe id="video"
              style=" width: 100%; height: 100%; position: absolute;"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen srcdoc='
              <div class="container" id="vid_6ad716f6955e8429a58942f8ee64fbf8" style="position:relative;width:100%;padding: 56.25% 0 0;"> <img id="thumb_6ad716f6955e8429a58942f8ee64fbf8" src="https://dkplayer.s3.sa-east-1.amazonaws.com/emerson_matos-Id1/UploadFolderVideos/d666ea35263e49dc728c2305cc2bab/fe9f1cdd-ace1-4905-a0d5-5a3794eedc61_VSL-Booster/Frame/frame-6ad716f6955e8429a58942f8ee64fbf8.png" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;"> </div> <script type="text/javascript" id="scr_6ad716f6955e8429a58942f8ee64fbf8">var s=document.createElement("script");s.id="teste", s.src="https://vsl-booster-prod.s3.amazonaws.com/min/script.min.js",s.type="module", s.async=!0,document.head.appendChild(s); </script>
    '></iframe>
    </div>

<!--    <div class="mt-16 mb-8 px-8">-->
<!--      <h2 class="text-gray-500 mt-16 text-xs font-medium uppercase tracking-wide">-->
<!--        Anexos-->
<!--      </h2>-->
<!--      <div class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">-->
<!--        <div>-->
<!--          <a-->
<!--            target="_blank"-->
<!--            download=""-->
<!--            href="https://storage.googleapis.com/assets.kiwify.com.br/mNNutSysZagTpM0/pasta-teste-arquivo_522c258333b64d57bdf4ce5615ec17ff.zip"-->
<!--            class="col-span-1 flex shadow-sm rounded-md cursor-pointer"-->
<!--          >-->
<!--            <div-->
<!--              class="flex-shrink-0 flex items-center uppercase justify-center w-16 bg-pink-600 text-white text-sm leading-5 font-medium rounded-l-md"-->
<!--            >-->
<!--              zip-->
<!--            </div>-->
<!--            <div-->
<!--              class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"-->
<!--            >-->
<!--              <div class="flex-1 px-4 py-2 text-sm leading-5 truncate"><span-->
<!--                                                                         class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"-->
<!--                                                                       >pasta teste arquivo.zip</span>-->
<!--                <p class="text-gray-500">-->
<!--                  0.01 MB-->
<!--                </p></div>-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <button @click="gerarUid">
      Gerar UID
    </button>
    <b-card class="custom-card align-items-center justify-content-center">
      <b-card-code
        title="Você pode anexar arquivos"
        class=" "
      >
        <el-upload
          class="upload-demo d-flex "
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="handleChange"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div
            slot="tip"
            class="el-upload__tip"
          />
        </el-upload>
      </b-card-code>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import { BCard } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

export default {
  components: {
    BCardCode,
    BCard,
  },
  data() {
    return {
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
    }
  },
  methods: {
    gerarUid() {
      const uid = Math.floor(Math.random() * 1000000000000).toString().padStart(13, '0')
      console.log(uid) // exibe o UID no console
    },
    handlePreview(file) {
      console.log('Arquivo pré-visualizado:', file)
    },
    handleRemove(file, fileList) {
      console.log('Arquivo removido:', file)
      console.log('Lista de arquivos:', fileList)
    },
    handleChange(file) {
      console.log('handleChange chamado')
      console.log('file', file)
      this.handleUpload(file)
    },
    async handleUpload(file) {
      const formData = new FormData()
      const caminho = 'emerson_matos-Id1/Nova-pasta/'
      formData.append('file', file)
      formData.append('caminho', caminho)
      console.log('formData', formData)
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/UploadArquivos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
        console.log('response', response)
      })
    },

  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/cardfile.scss';
</style>
